const htmlContent = `
<div id="markdown">
<h1 id="imprint">Imprint</h1>
<p>Dipl.-Inform. Ludwig Prager<br>Gschwendt 1<br>84559 Kraiburg a.Inn, Germany  </p>
<p>Phone: <a href="tel:+49897602075">+49 89 7602075</a><br>Mobile: <a href="tel:+4917648285442">+49 176 48285442</a><br>Email:  <a href="mailto:info@celp.de">info@celp.de</a>  </p>
<p>VAT identification number per § 27a of the German VAT Act (UStG):<br>DE203694803</p>
<p>Responsible for content per § 55 II RStV: Ludwig Prager</p>

</div>
`;
export default htmlContent
